/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Operation {
    ADD = 'add',
    REMOVE = 'remove',
    REPLACE = 'replace',
}
